import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useExpertRatingContext } from "@limitless/expert";
import { formatRating } from "@limitless/common/utils";

const useStyles = makeStyles(theme => ({
    headerText: {
        display: "flex",
        flexDirection: "row"
    },
    text: {
        marginLeft: "3px"
    },
    progressbar: {
        width: "150px",
        height: "150px",
        margin: "auto",
        marginBottom: "14px",
        content: "75%",
        borderRadius: "50%",
        background: props => {
            const { custRating, isPracticeGroup } = props;

            return `radial-gradient(closest-side, ${
                theme.palette.background.elevation1
            } 85%, transparent 80% 100%),conic-gradient(${
                custRating >= 80 && !isPracticeGroup()
                    ? theme.palette.secondary.main
                    : custRating >= 50 && !isPracticeGroup()
                    ? "#FFC369" // orange
                    : (custRating > 0 && !isPracticeGroup()) || (isNaN(custRating) && !isPracticeGroup())
                    ? theme.palette.error.main
                    : theme.palette.secondary.light
            } ${isNaN(custRating) ? 0 : custRating}%, ${
                custRating >= 80
                    ? theme.palette.secondary.light
                    : custRating >= 50
                    ? theme.palette.warning.light
                    : custRating > 0 || isNaN(custRating)
                    ? theme.palette.error.light
                    : theme.palette.secondary.light
            } 0)`;
        },
        animation: " progress 2s 1 forwards"
    }
}));

const RatingScore = () => {
    const { custRating, group, ratingMessagesCount, isPracticeGroup } = useExpertRatingContext();

    const classes = useStyles({ custRating, isPracticeGroup });

    const getText = React.useMemo(() => {
        if (custRating >= 80) {
            return "Keep it up!";
        } else if (custRating >= 50) {
            return "See the tips below on how to improve";
        } else if (custRating > 0) {
            return "See the tips below on how to improve";
        } else {
            return "Answer more questions in order to gain ratings";
        }
    }, [custRating]);

    return (
        <Grid container sx={{ padding: 3 }}>
            <Grid item xs={12}>
                <Grid className={classes.headerText}>
                    <Typography color={theme => theme.palette.text.primary} variant="h6">
                        Rating Score
                    </Typography>
                </Grid>
                <Typography color={theme => theme.palette.text.secondary} variant="caption">
                    {isPracticeGroup()
                        ? ""
                        : custRating > 0
                        ? group.value === "all"
                            ? `based on your last ${ratingMessagesCount} ratings across all groups`
                            : `based on your last ${ratingMessagesCount} ratings`
                        : "you need at least 5 recent ratings for a score"}
                </Typography>
                <Grid marginTop={2} sx={{ textAlign: "center" }}>
                    <div className={classes.progressbar}>
                        <Typography sx={{ paddingTop: "46px" }} variant="h3">
                            {custRating > 0 && !isPracticeGroup() ? `${formatRating(custRating)}` : "n/a"}
                        </Typography>
                    </div>
                    <Typography color={theme => theme.palette.text.secondary} variant="body2">
                        {!isPracticeGroup() ? getText : ""}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};
RatingScore.propTypes = {
    custRating: PropTypes.number
};
export default RatingScore;
